import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {NEVER, Observable} from 'rxjs';
import {AuthenticationService} from '@services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class BlockRequestInterceptorService implements HttpInterceptor {

  constructor(private _authenticationService: AuthenticationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!navigator.onLine || this._authenticationService.authRefreshError) {
      console.log('Request blocked because no connection');
      return NEVER;
    }
    return next.handle(req);
  }
}

